module.exports = __webpack_public_path__ + "img/ico_badge11.975b4544.svg";